import { Modal, Button } from "react-bootstrap";

const PrintColumnModal = ({
  isOpen,
  onClose,
  columns,
  columnVisibility,
  toggleColumn,
  handleSelectAll,
  handleDeselectAll,
  allSelected,
  noneSelected,
  onPrint
}) => {
  return (
    <Modal show={isOpen} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Columns to Print</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="w-full bg-white p-6 rounded-xl">

          {/* Header */}
          <div className="flex justify-between items-center mb-6">
            <p className="text-gray-700 text-lg font-semibold">
              {columns.length} Columns
            </p>

            <div className="flex gap-3">
              <button
                onClick={handleSelectAll}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition
                ${allSelected
                    ? "bg-blue-700 text-white shadow-md"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
              >
                Select All
              </button>

              <button
                onClick={handleDeselectAll}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition
                ${noneSelected
                    ? "bg-blue-700 text-white shadow-md"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
              >
                Deselect All
              </button>
            </div>
          </div>

          {/* Column Grid */}
          <div
            className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4
            max-h-96 overflow-y-auto pr-2"
          >
            {columns.map((col) => (
              <label
                key={col.key}
                className={`flex items-center gap-3 p-3 rounded-xl border 
                cursor-pointer transition
                ${columnVisibility[col.key]
                    ? "border-blue-500 bg-blue-50"
                    : "border-gray-200 hover:border-blue-300 hover:bg-blue-50"
                  }`}
              >
                <input
                  type="checkbox"
                  className="w-5 h-5 accent-blue-600 cursor-pointer"
                  checked={!!columnVisibility[col.key]}
                  onChange={() => toggleColumn(col.key)}
                />

                <span className="text-gray-800 break-words font-medium">
                  {col.label}
                </span>
              </label>
            ))}
          </div>

        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          Close
        </Button>

        <button
          className="px-6 py-2 rounded-lg bg-orange text-white 
          hover:bg-dark-orange font-medium transition"
          onClick={onPrint}
        >
          Print Selected
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PrintColumnModal;